export default __webpack_public_path__ + "static/fort-anne-thumb-caa76cc50546c7e6458feca60aaac881.jpg";